
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EmpresaPage = lazy(() => import('../pages/empresa/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const PoliticaCookiesPage = lazy(() => import('../pages/politica-cookies/page'));
const AvisoLegalPage = lazy(() => import('../pages/aviso-legal/page'));
const PoliticaPrivacidadPage = lazy(() => import('../pages/politica-privacidad/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/empresa',
    element: <EmpresaPage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/politica-cookies',
    element: <PoliticaCookiesPage />,
  },
  {
    path: '/aviso-legal',
    element: <AvisoLegalPage />,
  },
  {
    path: '/politica-privacidad',
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
